import ActionTypeItem from "../ActionTypeItem";

export default class ActualizarItem extends ActionTypeItem {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        /* nuevoEstado.flag.sensorDeAccionActualizar = !(estado.flag.sensorDeAccionActualizar); */
        return nuevoEstado;
    }
}
